module.exports = __webpack_public_path__ + "static/media/sun-fogoutline.d3e576a1.svg";